import { createContext, SetStateAction, useContext, useState } from "react";

interface UsersIntegrationContextType {
  ownerId: string;
  password: string;
  registeredPassbooks: string[];
  setOwnerId: React.Dispatch<SetStateAction<string>>;
  setPassword: React.Dispatch<SetStateAction<string>>;
  setRegisteredPassbooks: React.Dispatch<SetStateAction<string[]>>;
  resetUsersIntegrationInfo: () => void;
}

const UsersIntegrationContext = createContext<UsersIntegrationContextType | undefined>(undefined);

export const UsersIntegrationProvider = ({children}: {children: React.ReactNode}) => {
  const [ownerId, setOwnerId] = useState("");
  const [password, setPassword] = useState("");
  const [registeredPassbooks, setRegisteredPassbooks] = useState<string[]>([]);

  const resetUsersIntegrationInfo = () => {
    setOwnerId("");
    setPassword("");
    setRegisteredPassbooks([]);
  };

  return (
    <UsersIntegrationContext.Provider
      value={{
        ownerId,
        password,
        registeredPassbooks,
        setOwnerId,
        setPassword,
        setRegisteredPassbooks,
        resetUsersIntegrationInfo,
      }}
    >
      {children}
    </UsersIntegrationContext.Provider>
  );
};

export const useUsersIntegrationContext = () => {
  const context = useContext(UsersIntegrationContext);
  if (!context) throw new Error("UsersIntegrationContext must be used within UsersIntegrationProvider");
  return context;
};